import { ResourcesConfig } from "aws-amplify";

const awsConfig: ResourcesConfig = {
    Auth: {
        Cognito: {
        //  Amazon Cognito User Pool ID
        userPoolId: 'ap-southeast-2_4RZ7iI5f7',
        // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
        userPoolClientId: '1pakgui8lic8n3l6naqr2mg7c0',
        identityPoolId: 'ap-southeast-2:7819ca54-270c-45db-93f1-0d9f1e89afb8',
        allowGuestAccess: false,
        loginWith: {
            // OPTIONAL - Hosted UI configuration
            oauth: {
            domain: 'auth.capsuletime.co',
            scopes: [
                'email',
                'openid',
                'phone',
                'profile'
            ],
            redirectSignIn: [process.env.REACT_APP_REDIRECT_SIGNIN!],// || 'http://localhost:3000'],
            redirectSignOut: [process.env.REACT_APP_REDIRECT_SIGNIN!],// || 'http://localhost:3000'],
            responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
            }
        }
        }
    }
    };
  
export default awsConfig;
  
